import { render, staticRenderFns } from "./MarkdownDocumentModal.vue?vue&type=template&id=ed32a63a"
import script from "./MarkdownDocumentModal.vue?vue&type=script&lang=js"
export * from "./MarkdownDocumentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports